import { DisclaimerDataMapInterface } from './DisclaimerTypes';

export const dataMap: DisclaimerDataMapInterface = {
  'insured-with-approved-gr': {
    highlight: 'Proteção Frete Seguro:',
    description:
      'Se a carga for roubada, você deve comprovar o pagamento da apólice do seguro para receber até R$ 20.000 de reembolso pago pela Fretebras.',
    icon: {
      name: 'lock',
      styled: 'filled',
    },
    color: 'blue',
  },
  'insured-with-reproved-gr': {
    highlight: 'Atenção!',
    description:
      'Carregar com motorista sem perfil securitário na GR Fretebras anula o benefício de reembolso da franquia incluso no Frete Seguro.',
    icon: {
      name: 'alert',
      styled: 'outlined',
    },
    color: 'orange',
  },
  'insured-without-gr': {
    highlight: 'Proteção Frete Seguro:',
    description:
      'Se a carga for roubada, você deve comprovar o pagamento da apólice do seguro para receber até R$ 20.000 de reembolso pago pela Fretebras.',
    icon: {
      name: 'lock',
      styled: 'filled',
    },
    color: 'blue',
  },
  'not-insured': null,
  'rejected-trucker': null,
};
